<template>
<div class="x_box">
    <ol class="breadcrumb x_breadcrumb">
        <li class="breadcrumb-item">
           <router-link to="/sale/invoices">{{ $t('sale_invoice_list') }}</router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{ $t('new') }}</li>
    </ol>
    <div class="x_header">
        <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-chevron-circle-left" aria-hidden="true"></i> {{ $t('back') }}</button>
        <b-btn variant="outline-primary no-bor"
               size="sm"
               @click="clickSaveHandler">
            <i class="fa fa-floppy-o" aria-hidden="true" /> {{$t('save')}}
        </b-btn>
        <b-btn variant="outline-primary no-bor"
               size="sm"
               @click="clickPrintHandler">
            <i class="fa fa-print" aria-hidden="true" /> {{$t('print')}}
        </b-btn>
    </div>
    <div class="x_body">
        <div class="card f_card">
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-2">
                        <div class="form-group">
                            <label class="control-lable blue">{{ $t('customer') }}</label>
                            <div>
                                <CustomerDropdown @select="customerSelected" :value="invoice.CustomerName" />
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="form-group">
                            <label class="control-lable blue">{{ $t('date') }}</label>
                            <div>
                                <input type="date" class="form-control form-control-sm" v-model="date" @change="onDateChange" />
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="form-group">
                            <label class="control-lable blue">{{ $t('due_date') }}</label>
                            <div>
                                <input type="date" class="form-control form-control-sm" v-model="due_date" />
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col-sm-12">
                        <table class="grid">
                            <thead>
                                <tr>
                                    <th style="width: 30px;"></th>
                                    <th>{{$t('item_name')}}</th>
                                    <th style="width: 120px;">{{$t('uom')}}</th>
                                    <th style="width: 120px;">{{$t('qty_in_stock')}}</th>
                                    <th style="width: 120px;">{{$t('qty_sale')}}</th>
                                    <th style="width: 120px;">{{$t('cost')}}</th>
                                    <th style="width: 120px;">{{$t('price_sale')}}</th>
                                    <th style="width: 120px;">{{$t('discount')}}(%/$)</th>
                                    <th class="text-right" style="width: 120px;">{{$t('sub_total')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(ret,index) in lines" :key="ret.Id">
                                    <td style="width: 30px;">
                                            <button type="button"
                                                    class="btn btn-danger btn-remove"
                                                    @click="removeLine(index)">
                                                X
                                            </button>
                                        </td>
                                    <td>
                                        <AuthCompleted @select="select($event, ret)" :value="ret.ItemName"/>
                                    </td>
                                    <td>
                                        <UomDropdown :value="ret.UomName" :item_id="ret.ItemId" @select="uomChange($event, ret)"></UomDropdown>
                                    </td>
                                    <td class="text-center">
                                        <input type="number" class="form-control form-control-sm" v-model="ret.QtyInStock" readonly />
                                    </td>
                                    <td class="text-center" :class="{'form-group-error': ret.Quantity>ret.QtyInStock}">
                                        <input type="number" class="form-control form-control-sm" v-model="ret.Quantity"
                                               :disabled="ret.ItemId==''"
                                               @keypress="$isKeyNumber"
                                               @change="reCalculate">
                                    </td>
                                    <td class="text-center">
                                        <input type="number" class="form-control form-control-sm" v-model="ret.Cost" readonly />
                                    </td>
                                    <td class="text-right" :class="{'form-group-error': ret.Price<=ret.Cost}">
                                        <input type="number"
                                               class="form-control form-control-sm"
                                               v-model="ret.Price"
                                               :disabled="permission != 1 || ret.ItemId==''"
                                               @keypress="$isKeyNumber"
                                               @change="reCalculate">
                                    </td>
                                    <td class="text-right">
                                        <div class="input-group">
                                            <input type="number"
                                                   class="form-control form-control-sm"
                                                   aria-describedby="dis-addon"
                                                   v-model="ret.Discount"
                                                   :disabled="ret.ItemId=='' || discountRate>0"
                                                   @keypress="$isKeyNumber"
                                                   @change="reCalculate">
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="dis-addon" style="padding: 3px; width:30px; justify-content:center; cursor: pointer;" @click="onChangeDis(ret)">{{ret.DiscountType===1?'$':'%'}}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="text-right">
                                        <input type="text"
                                               class="form-control form-control-sm text-right"
                                               :value="$money(ret.SubTotal)" readonly />
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th></th>
                                    <th rowspan="4" class="v-top">
                                        <button type="button"
                                                class="btn btn-outline-primary btn-sm no-bor"
                                                @click="addLine">
                                            <i class="fa fa-plus" /> {{ $t('add_line') }}
                                        </button>
                                    </th>
                                    <th colspan="6" class="text-right">{{$t('grand_total')}}:</th>
                                    <th class="text-right">{{$money(invoice.GrandTotal)}}</th>
                                </tr>
                                <tr>
                                    <th></th>
                                    <th colspan="6" class="text-right">{{$t('discount')}} <span v-if="discountRate>0">({{ discountRate }}%)</span>:</th>
                                    <th class="text-right">{{$money(invoice.Discount)}}</th>
                                </tr>
                                <tr>
                                    <th></th>
                                    <th colspan="6" class="text-right">{{$t('total_amount')}}:</th>
                                    <th class="text-right">{{$money(invoice.TotalAmount)}}</th>
                                </tr>
                                <tr>
                                    <th></th>
                                    <th colspan="6" class="text-right">{{$t('point')}}:</th>
                                    <th class="text-right">{{ invoice.Point }}</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
                <br>
                <hr>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="control-lable blue">{{ $t('noted') }}</label>
                            <div>
                                <textarea class="form-control form-control-sm" v-model="invoice.Description"> </textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    import { AuthCompleted } from '../Item';
    import { CustomerDropdown } from '../Customer';
    import UomDropdown from '../UOM/Dropdown';
    import moment from 'moment';
    import print from '../PDF/Prints/Receipt.js';

    export default {
        components: {
            AuthCompleted,
            CustomerDropdown,
            UomDropdown
        },
        data: function(){
            return {
                invoice: {
                    CustomerId: '',
                    CustomerName: '',
                    CustomerTypeId: '',
                    GrandTotal: 0,
                    UntaxAmount: 0,
                    ExchangeRate: 0,
                    Description: '',
                    PointRate: 0,
                    Point: 0
                },
                lines: [{
                    ItemId: '',
                    ItemName: '',
                    QtyInStock: 0,
                    Quantity: 1,
                    DiscountType: 1,
                    DiscountAmount: 0,
                    UomId: '',
                    UomName: '',
                    TaxLine: 0,
                    Discount: 0,
                    Price: 0,
                    Cost: 0,
                    SubTotal: 0,
                    ExchangeRate: 0,
                }],
                date: this.$now().format('YYYY-MM-DD'),
                due_date: this.$now().format('YYYY-MM-DD'),
                actionLink: 'sale/invoice/save',
                types: [],
                discountRate: 0
            }
        },
        async created(){
            let id = this.$route.params.id;
            if(id != undefined && id != null && id != ''){
                var loading = this.$loading.show();
                this.actionLink = 'sale/invoice/update';
                this.$api().post('sale/invoice/find', { Id: id }).then(res => {
                    var data = res.data.Data;
                    this.invoice = data.SaleInvoice;
                    this.lines = data.SaleInvoiceLines;
                    this.date = this.$format(this.invoice.Date, 'YYYY-MM-DD');
                    this.due_date = this.$format(this.invoice.DueDate, 'YYYY-MM-DD');
                }).finally(function() { loading.hide(); });
            }
            await this.typeList();
        },
        methods: {
            async typeList(){
                var res = await this.$api().post('customer/types');
                if(this.$isValid(res)){
                    this.types = res.data.Json.Types;
                }
            },
            async clickSaveHandler(){
                try {
                    this.invoice.Date = this.date;
                    this.invoice.DueDate = this.due_date;
                    
                    const req = {
                        Header: this.invoice,
                        Lines: this.lines
                    };
                    
                    var loading = this.$loading.show();
                    const res = await this.$api().post(this.actionLink, req);
                    
                    if (this.$isValid(res)) {
                        this.$router.push('/sale/invoices');
                    }
                } catch (error) {
                    this.$notify.error('Failed to save invoice');
                } finally {
                    loading.hide();
                }
            },
            clickPrintHandler() {
                print(this.$store.state.company, this.invoice, this.lines, this.$money);
            },
            select(item, line){
                line.ItemId = item.Id;
                line.ItemName = item.Name;
                line.Price = item.Price;
                line.UomId = item.UomId;
                line.UomName = item.UomName;
                line.Cost = item.Cost;
                line.QtyInStock = item.EndingQty;
                this.reCalculate();
            },
            customerSelected(item) {
                this.invoice.CustomerId = item.Id;
                this.invoice.CustomerTypeId = item.CustomerTypeId;
                this.invoice.CustomerName = item.Name;
                if (item.PointRate != undefined && item.PointRate != null && item.PointRate != '') {
                    this.invoice.PointRate = item.PointRate;
                }

                this.discountRate = item.DiscountRate != undefined && item.DiscountRate != null ? item.DiscountRate : 0;
                this.updateDiscountRate();
                this.updateDueDate();
                this.reCalculate();
            },
            updateDiscountRate() {
                this.lines.map(line => {
                    line.DiscountType = 2;
                    line.Discount = Number(this.discountRate);
                });
            },
            calculateCustomerPoint() {
                if (this.invoice.PointRate > 0) {
                    this.invoice.Point = (this.invoice.TotalAmount / this.invoice.PointRate).toFixed(2);
                }
            },
            reCalculate(){
                let grand = 0;
                let totalDis = 0;
                let untax = 0;
                let totalVat = 0;
                let totalAmount = 0;
                this.lines.map(item => {
                    let discount = item.DiscountType == 1? item.Discount: item.Price * item.Discount / 100;
                    let newPrice = item.Price - discount;
                    let total = item.Quantity * newPrice;
                    let taxVat = total * (item.TaxLine / 100);
                    let subTotal = total + taxVat;
                    item.SubTotal = subTotal;
                    totalDis += discount * item.Quantity;
                    untax += total;
                    totalVat += taxVat;
                    grand += item.Quantity * item.Price;
                    totalAmount += subTotal;
                });
                this.invoice.GrandTotal = grand;
                this.invoice.Discount = totalDis;
                this.invoice.UntaxAmount = untax;
                this.invoice.TaxVat = totalVat;
                this.invoice.TotalAmount = totalAmount;
                this.invoice.Balance = totalAmount;
                this.calculateCustomerPoint();
            },
            addLine(){
                this.lines.push({
                    ItemId: '',
                    ItemName: '',
                    QtyInStock: 0,
                    Quantity: 1,
                    DiscountAmount: 0,
                    DiscountType: 1,
                    UomId: '',
                    UomName: '',
                    TaxLine: 0,
                    Discount: this.discountRate > 0 ? Number(this.discountRate) : 0,
                    Price: 0,
                    Cost: 0,
                    SubTotal: 0
                });
            },
            removeLine(index){
                this.lines.splice(index, 1);
                this.reCalculate();
            },
            uomChange(e, line){
                line.UomId = e.UomId;
                line.UomName = e.UomName;
                line.Price = e.Price;
                line.Cost = e.Cost;
                this.reCalculate();
            },
            onDateChange(){
                this.updateDueDate();
            },
            onChangeDis(line){
                if(line.DiscountType === 1) line.DiscountType = 2;
                else line.DiscountType = 1;
                if(line.ItemId !== '') this.reCalculate();
            },
            updateDueDate(){
                const ctype = this.types.find(el => el.Id === this.invoice.CustomerTypeId);
                if(ctype !== undefined){
                    this.due_date = moment(this.date).add(ctype.DueDay, 'days').format('YYYY-MM-DD');
                }else{
                    if(moment(this.date).diff(this.due_date, 'days') > 0) this.due_date = this.date;
                }
            }
        },
        computed: {
            permission(){
                return this.$store.state.userGroup;
            }
        }
    }
</script>
<style scoped>
    label{
        margin-bottom: 0;
    }
</style>
